export const formLabelClassName =
  'block text-[11px] font-medium uppercase tracking-[0.05em] text-[#6B6560]';

export const formInputClassName =
  'w-full rounded-xl border border-[#E2DDD8] bg-[#F9F7F4] px-3 py-2.5 text-sm text-[#1A1714] outline-none transition focus:border-[#185FA5] focus:bg-[#FFFFFF] focus:ring-4 focus:ring-[rgba(24,95,165,0.08)] disabled:cursor-not-allowed disabled:bg-[#EFEAE3] disabled:text-[#8D867E]';

export const formSelectClassName = formInputClassName;

export const formTextAreaClassName =
  `${formInputClassName} min-h-[92px] resize-none`;

export const formHelpTextClassName = 'mt-1 text-sm text-[#7C766F]';

export const formErrorTextClassName = 'mt-1 text-sm text-[#A32D2D]';
